import { useEffect, useState } from "react";
import img from "../assets/sb_logo.png";
import { IoMdSettings, IoMdNotifications } from "react-icons/io";
import { IoAppsSharp } from "react-icons/io5";
import Profiledropdown from "./Profiledropdown";
import Mainmenu from "./Main-menu";
import { useNavigate } from "react-router-dom";
import PopBox from "../Components/Popup/Popup";
import Select from "react-select";
import {useGetCompanyQuery,usePostSetCompanyMutation,useGetSelectedCompanyQuery} from "../store/api/companyapi";
import {getCompanyStatus,storeCompanyStatus} from "../Localstorage/Localstorage";

const Header = () => {
  const nvg = useNavigate();
  const companystatus = getCompanyStatus();
  const isCompanySelected = companystatus;

  const { data: companyData } = useGetCompanyQuery();
  const { refetch: refetchSelectCompany } = useGetSelectedCompanyQuery();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const getcompany = useGetSelectedCompanyQuery();
  const selectedComapny = getcompany?.data?.message?.data?.company;
  const [setcompanyapi] = usePostSetCompanyMutation();
  const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const options = companyData?.result?.map((company) => ({
      value: company.abbr,
      label: company.company_name,
    })) || [];


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#fc8b5c" : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #fc8b5c" : "none",
      "&:hover": { borderColor: "#fc8b5c" },
    }),
    option: (provided, { isSelected }) => ({
      ...provided,
      backgroundColor: isSelected ? "#fc8b5c" : "white",
      color: isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: "#fc8b5c",
        color: "white",
      },
    }),
  };

  useEffect(() => {
    if (companystatus !== "true") {
      setIsPopBoxOpen(true);
    }
    setSelectedCompany(getcompany?.data?.message?.data?.company);
  }, [companystatus, getcompany]);

  const setcompany = async (selected) => {
    try {
      const response = await setcompanyapi({ name: selected.label });
      if (response.data) {
        setSelectedCompany(selected.label);
        setIsPopBoxOpen(false);
        storeCompanyStatus("true");
        refetchSelectCompany();
      }
      if (response.error) {
        setErrorMessage("You do not have permission to access this company");
      }
    } catch (error) {
      console.log("check set compamy error", error);
    }
  };

  return (
    <>
      <header className="header d-flex justify-content-between align-items-center">
        {/* Left side: Hamburger and Logo */}
        <div className="d-flex align-items-center">
          <p className="m-0">
            <Mainmenu />
          </p>
          <div className="logo mt-0">
            <img
              src={img}
              onClick={() => {
                nvg("/dashboard/");
              }}
              style={{ maxHeight: "50px", cursor: "pointer" }}
              alt="logo"
            />
          </div>
        </div>
        {/* Right side: Icons and Dropdown */}
        <div className="d-flex align-items-center mx-1">
          <a href="javascript:void(0);" className="me-2 d-flex">
            <IoMdSettings color="white" size={20} />
          </a>
          <a href="javascript:void(0);" className="me-2 d-flex">
            <IoMdNotifications color="white" size={20} />
          </a>
          <a href="javascript:void(0);" className="me-2 d-flex">
            <IoAppsSharp color="white" size={19} />
          </a>
          <a href="javascript:void(0);"  onClick={() => {
              setIsPopBoxOpen(true);
            }} className=" btn me-2 d-flex companyHeader" >
          {selectedCompany}
          </a>
          <div className="dropdown">
            <Profiledropdown />
          </div>
        </div>
      </header>
      <PopBox
        isOpen={isPopBoxOpen}
        onClose={() => setIsPopBoxOpen(false)}
        title="Select Company"
      >
        <div>
          <div className="selectbox">
            <Select
              options={options}
              styles={customStyles}
              onChange={setcompany}
              value={options.find((option) => option.label === selectedComapny)}
            />
          </div>
          {isCompanySelected && (
            <div style={{height:'2px'}}>
              <button onClick={() => setIsPopBoxOpen(false)} className="custom-btn101">
                &times;
              </button>
            </div>
          )}
        </div>
        {errorMessage && (
          <div style={{ color: "red", textAlign: "center" }}>
            {errorMessage}
          </div>
        )}
      </PopBox>
    </>
  );
};

export default Header;
